import React from 'react';
import history from 'app/routes/history';
import IActions from 'app/types/actions';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  ITeamsSelector,
} from 'app/types/selector';
import HeaderThin from 'app/components/layout/HeaderThin';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import TeamsTable from 'app/components/teams/TeamsTable';
import * as teamActions from 'app/ducks/teams/actions';

import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';

interface ITeamsListProps {
  teams: ITeamsSelector;
  actions: IActions;
  appReady: boolean;
  match: any;
}

function selector(state): any {
  return {
    teams: teamsSelectors.getTeams(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamActions,
);

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class TeamsList extends React.Component<ITeamsListProps, {}> {
  static defaultProps = {
    teams: {},
    actions: undefined,
    match: {},
  };

  // componentDidMount(): void {
  //   this.props.actions.getAllTeams();
  // }

  // componentDidUpdate(prevProps): void {
  //   if (this.props.teams.hasLoaded && this.props.teams.teamIds.length === 0) {
  //     // console.log('none found', this.props, this.props.teams.teamIds.length);
  //     history.push('/create-team');
  //   }
  // }

  render(): React.ReactNode {
    return (
      <div className="h-100 m-h-100">
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Teams"
              // divider
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <TeamsTable
              {...this.props.teams}
              appReady={this.props.appReady}
              actions={this.props.actions}
              match={this.props.match}
              isLoading={this.props.teams.isLoading}
              subtitleClassName="grey"
              showChildren
            />
          </div>
        </div>
      </div>
    );
  }
}
